module.exports = __webpack_public_path__ + "static/img/logo-stripe-light.44689a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-stripe-light.png
// module id = dvzB
// module chunks = 0